import { render, staticRenderFns } from "./Thumbs.vue?vue&type=template&id=3ac9f7b8&scoped=true&"
import script from "./Thumbs.vue?vue&type=script&lang=js&"
export * from "./Thumbs.vue?vue&type=script&lang=js&"
import style0 from "./Thumbs.vue?vue&type=style&index=0&id=3ac9f7b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac9f7b8",
  null
  
)

export default component.exports